import { rootApi } from '../rootApi';

export const karsanStockVehiclesReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getKarsanStockVehiclesReport: builder.query({
            query: (params) => ({
                url: 'v1/sapfinishedvehicle/getallreport',
                method: 'POST',
                body: {
                    pageNumber: params.pageNumber,
                    pageSize: params.pageSize,
                    languageId: params.languageId,
                    filters: params.filters || null,
                    sorts: params.sorts || null
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount
                    };
                }
                return { items: [], totalCount: 0 };
            }
        }),
        getDealerStockReport: builder.query({
            query: (params) => ({
                url: 'v1/sapfinishedvehicle/getdealerstockreport',
                method: 'POST',
                body: {
                    pageNumber: params.pageNumber,
                    pageSize: params.pageSize,
                    languageId: params.languageId,
                    filters: params.filters || null,
                    sorts: params.sorts || null,
                    includeFilterOptions: params.includeFilterOptions ?? false,
                    filterOptionsColumns: params.filterOptionsColumns || null,
                    dealerId: params.dealerId || null
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount,
                        filterOptions: response.data.filterOptions || null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            }
        }),
        getKarsanStockBrandModelOptions: builder.query({
            query: ({ brand } = {}) => ({
                url: 'v1/sapfinishedvehicle/GetKarsanStockBrandModelOptions',
                params: brand ? { brand } : {}
            }),
            transformResponse: (response) => ({
                brands: response?.data?.brands ?? [],
                models: response?.data?.models ?? []
            })
        }),
        getDealerStockBrandModelOptions: builder.query({
            query: ({ brand, dealerId } = {}) => ({
                url: 'v1/sapfinishedvehicle/GetDealerStockBrandModelOptions',
                params: {
                    ...(brand ? { brand } : {}),
                    ...(dealerId ? { dealerId } : {})
                }
            }),
            transformResponse: (response) => ({
                brands: response?.data?.brands ?? [],
                models: response?.data?.models ?? []
            })
        }),
        getVehicleDealerStockDealerDropdown: builder.query({
            query: ({ SearchText = '', RowCount = 50 } = {}) => ({
                url: 'v1/sapfinishedvehicle/GetDealerStockDealerDropdown',
                params: { SearchText, RowCount }
            }),
            transformResponse: (response) => (Array.isArray(response?.data) ? response.data : [])
        })
    })
});

export const { useLazyGetKarsanStockVehiclesReportQuery, useLazyGetDealerStockReportQuery, useGetKarsanStockBrandModelOptionsQuery, useGetDealerStockBrandModelOptionsQuery, useGetVehicleDealerStockDealerDropdownQuery } = karsanStockVehiclesReportApi;
